import { render } from "./FullscreenModal2.vue?vue&type=template&id=916ef342&scoped=true"
import script from "./FullscreenModal2.vue?vue&type=script&lang=js"
export * from "./FullscreenModal2.vue?vue&type=script&lang=js"

import "./FullscreenModal2.vue?vue&type=style&index=0&id=916ef342&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-916ef342"]])

export default __exports__